export const dataHome = {
  cardPrincipal: {
    home: 'https://api.belladasemana.com.br/storage/home/1685382845e80a7eaec1d9962cba609da4463b760bb1813.jpg',
    name: 'Fernanda Campos',
    description: 'Modelo internacional e skatista.',
    text: `Com o corpo perfeito, a morena adora esportes radicais e mostrou toda a sua paixão pelo scate em nosso ensaio (incluse andou nua sobre ele).
        Ficou curioso? O resultado vai te enlouquecer!
        `
  },
  ultimosCards: [
    {
      name: 'Livia Santana',
      url: 'https://google.com',
      imgUrl:
        '	https://api.belladasemana.com.br/storage/home/16855367619121f99093a95fccda5ec0eb5a25051bb780.jpg'
    },
    {
      name: 'Mayara Salfer',
      url: 'https://google.com',
      imgUrl:
        '	https://api.belladasemana.com.br/storage/home/168553703050f928b5a27118ef7caa6bbc8b649cacb1739.jpg'
    }
  ],
  blogs: [
    {
      id: 1,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687188988-thumb-bmw.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 2,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    }
  ],
  columns: [
    {
      category: 'Cartas na mesa',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Destino exótico',
      cards: [
        {
          id: 1,
          title: 'Viajar, surfar',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Os melhores paises do mundo',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Entre o luxo e a ecologia',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Banho de luz noturno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Do que elas gostam',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Falando sobre sexo',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Mandicas',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Max pelo mundo',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Moda',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Paquera',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Personal Trainer',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Sommelier',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    },
    {
      category: 'Sthepany',
      cards: [
        {
          id: 1,
          title: 'Apenas Vença',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_9f2438939b8ca0445e39216be19e2eb6_thumb-blogpost.jpg'
        },
        {
          id: 2,
          title: 'Dicas de milionários para enriquecer',
          image:
            'https://api.belladasemana.com.br/storage/articles/cover_pt_e4426e29224df336b00eafdebb1a1ce0_thumb-blogpost-copia.jpg'
        },
        {
          id: 3,
          title: 'Bom mesmo é ter coragem',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.775022001395078096_capa_cartas.jpg'
        },
        {
          id: 4,
          title: 'Não quero nada morno',
          image:
            'https://api.belladasemana.com.br/storage/articles/0.066897001366813742_capa_cartas.jpg'
        }
      ]
    }
  ],
  bannerAssineHorizontal: 'https://api.belladasemana.com.br/storage/banners/1602865536.jpg',
  bannerFreeTour1: 'https://api.belladasemana.com.br/storage/banners/1655322574.jpg',
  bannerFreeTour2: 'https://api.belladasemana.com.br/storage/banners/1655322733.jpg',
  bannerEnsaioGratis: 'https://api.belladasemana.com.br/storage/banners/1655322733.jpg',
  arrayImagesFreeTour: [
    {
      name: 'Foto 1',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/1_cover.jpg',
      imgHorizontal: true
    },
    {
      name: 'Foto 2',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/2_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 3',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/3_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 4',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/4_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 5',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/5_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 6',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/10_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 7',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/7_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 8',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/8_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 9',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/9_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 10',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/6_cover.jpg',
      imgHorizontal: true
    },
    {
      name: 'Foto 11',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/11_cover.jpg',
      imgHorizontal: true
    },
    {
      name: 'Foto 12',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/12_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 13',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/13_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 14',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/14_cover.jpg',
      imgHorizontal: false
    },
    {
      name: 'Foto 15',
      imgSrc: 'https://api.belladasemana.com.br/storage/freetour/pictures/15_cover.jpg',
      imgHorizontal: false
    }
  ],
  plansFreeTour: [
    {
      id: 1,
      plan_name: 'Plano Brasil 2022',
      period: 'Anual',
      value: 179.99,
      in_cents: 50,
      discount: 50,
      discount_value: 0
    },
    {
      id: 2,
      plan_name: 'Plano Brasil 2022',
      period: 'Semestral',
      value: 119.99,
      in_cents: 67,
      discount: 33,
      discount_value: 0
    },
    {
      id: 3,
      plan_name: 'Plano Brasil 2022',
      period: 'Trimestral',
      value: 79.99,
      in_cents: 89,
      discount: 11,
      discount_value: 0
    },
    {
      id: 4,
      plan_name: 'Plano Brasil 2022',
      period: 'Mensal',
      value: 29.99,
      in_cents: 100
    }
  ]
}

export const dataModels = {
  postsCarroselModels: [
    {
      id: 1,
      title: 'Carolinny Viera',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767147bd858f728451e2c459ef48caa8293b754.jpg'
    },
    {
      id: 2,
      title: 'Renata Matos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767319c5cf8f80b68e6a31aaeb503ef26f8b136.jpg'
    },
    {
      id: 3,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 4,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689130984d162b0635b5b41bb08f8044003a76249b178.jpg'
    },
    {
      id: 5,
      title: 'Fernanda Campos',
      cover:
        '	https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    }
  ],
  modelsArray: [
    {
      id: 1,
      title: 'Carolinny Viera',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767147bd858f728451e2c459ef48caa8293b754.jpg'
    },
    {
      id: 2,
      title: 'Renata Matos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767319c5cf8f80b68e6a31aaeb503ef26f8b136.jpg'
    },
    {
      id: 3,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 4,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689130984d162b0635b5b41bb08f8044003a76249b178.jpg'
    },
    {
      id: 5,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 6,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 7,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 8,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 9,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 10,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 11,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 12,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    }
  ]
}

export const dataModel = {
  nameModel: 'Fernanda Campos',
  descriptionModel: 'Modelo internacional e skatista.',
  text: `Com o corpo perfeito, a morena adora esportes radicais e mostrou toda a sua paixão pelo scate em nosso ensaio (incluse andou nua sobre ele).
    Ficou curioso? O resultado vai te enlouquecer!`,
  imgPerfil: 'https://api.belladasemana.com.br/storage/capas/ec66f516f201733a158e5b4f93d642f9.jpg',
  shoot: [
    {
      name: 'Parte 1',
      sessions: [
        {
          name: 'Session 01',
          block: false,
          photos: [
            'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg',
            'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg',
            'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
          ]
        },
        {
          name: 'Session 02',
          block: true
        },
        {
          name: 'Session 03',
          block: true
        },
        {
          name: 'Session 04',
          block: true
        },
        {
          name: 'Session 05',
          block: true
        },
        {
          name: 'Session 06',
          block: true
        },
        {
          name: 'Session 07',
          block: true
        },
        {
          name: 'Session 08',
          block: true
        }
      ],
      videos: [
        {
          "name": "360p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "480p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "HD 720p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "Full HD 1080p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "4K",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        }
      ],
      lives: [
        {
          "name": "480p",
          "livePath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "HD 720p",
          "livePath": "http:\/\/localhost\/storage\/essay-live-videos\/pri-bianchini\/fullhd.mp4"
        },
        {
          "name": "Full HD 1080p",
          "livePath": ""
        },
        {
          "name": "4K",
          "livePath": "http:\/\/localhost\/storage\/essay-live-videos\/pri-bianchini\/fullhd.mp4"
        }
      ]      
    },
    {
      name: 'Parte 2',
      sessions: [
        {
          name: 'Session 01',
          block: true
        },
        {
          name: 'Session 02',
          block: true
        },
        {
          name: 'Session 03',
          block: true
        },
        {
          name: 'Session 04',
          block: true
        }
      ],
      videos: [
        {
          "name": "360p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "HD 720p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "Full HD 1080p",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "4K",
          "videoPath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        }
      ],
      lives: [
        {
          "name": "480p",
          "livePath": "https://api.belladasemana.com.br/storage/freetour/videos/fullhd.mp4"
        },
        {
          "name": "HD 720p",
          "livePath": "http:\/\/localhost\/storage\/essay-live-videos\/pri-bianchini\/fullhd.mp4"
        },
        {
          "name": "Full HD 1080p",
          "livePath": ""
        },
        {
          "name": "4K",
          "livePath": "http:\/\/localhost\/storage\/essay-live-videos\/pri-bianchini\/fullhd.mp4"
        }
      ]
    }
  ],
  profileQuestion: `
    <p><span style="font-size: 14pt;"><b>Nome:</b><span style="font-weight: 400;"> Fernanda Campos</span></span></p><p><span style="font-size: 14pt;"><b>Data e local de nascimento:</b><span style="font-weight: 400;"> 27/11/1996 - Curitiba / PR</span></span></p><p><span style="font-size: 14pt;"><b>Cidade onde mora atualmente: </b><span style="font-weight: 400;">Florian&oacute;polis / SC&nbsp;</span></span></p><p><span style="font-weight: 400; font-size: 14pt;">&nbsp;</span></p><p><span style="font-size: 14pt;"><b>Signo: </b><span style="font-weight: 400;">Sagit&aacute;rio</span></span></p><p><span style="font-weight: 400; font-size: 14pt;">&nbsp;</span></p><p><span style="font-size: 14pt;"><b>Medidas</b></span></p><p><span style="font-size: 14pt;"><b>Altura: </b><span style="font-weight: 400;">1,70</span></span></p><p><span style="font-size: 14pt;"><b>Quadril:</b><span style="font-weight: 400;"> 90</span></span></p><p><span style="font-size: 14pt;"><b>Cintura:</b><span style="font-weight: 400;"> 68</span></span></p><p><span style="font-size: 14pt;"><b>Busto:</b><span style="font-weight: 400;"> 80</span></span></p><p><span style="font-size: 14pt;"><b>P&eacute;s:</b><span style="font-weight: 400;"> 37</span></span></p><br /><br /><p><span style="font-size: 14pt;"><b>Voc&ecirc; &eacute; modelo internacional certo? Fale sobre alguns trabalhos que voc&ecirc; j&aacute; fez. </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Trabalhei com algumas campanhas locais da &Iacute;ndia e Tail&acirc;ndia, algumas na &aacute;rea de vestu&aacute;rios t&iacute;picos da regi&atilde;o e algumas campanhas de cosm&eacute;ticos como a famosa rede Tresemm&eacute; e tamb&eacute;m na &aacute;rea de eletr&ocirc;nico Xiaomi.&nbsp;</span></span></p><br /><p><span style="font-size: 14pt;"><b>Conta pra gente a sua experi&ecirc;ncia de modelar na Tail&acirc;ndia&hellip;&nbsp; </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Foram apenas tr&ecirc;s meses de um mercado extremamente concorrido voltado para a &aacute;rea de est&eacute;tica. Pude conhecer uma cultura sens&iacute;vel e religiosa. Aprendendo muito sobre sobreviv&ecirc;ncia sozinha em um pa&iacute;s com tanta diversidade.</span></span></p><br /><p><span style="font-size: 14pt;"><b>Em nossa transmiss&atilde;o do ensaio ao vivo, descobrimos a sua paix&atilde;o pelo skate. Quando come&ccedil;ou? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Quando completei 18 anos trabalhei em uma surf shop em Balne&aacute;rio Cambori&uacute; e me apaixonei pelas rodinhas .</span></span></p><br /><p><span style="font-size: 14pt;"><b>Voc&ecirc; j&aacute; participou de competi&ccedil;&otilde;es ou anda s&oacute; por divers&atilde;o? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Apenas entre amigos at&eacute; agora...</span></span></p><br /><p><span style="font-size: 14pt;"><b>Pratica algum outro esporte radical? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Por hora o skate me parece radical o suficiente..</span></span></p><br /><p><span style="font-size: 14pt;"><b>O que voc&ecirc; te leva a loucura na hora H? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Aprecio a tatibilidade oral.&nbsp;</span></span></p><br /><p><span style="font-size: 14pt;"><b>Tem algum apelido? Como os familiares e amigos costumam te chamar?</b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Eu sempre fui a Moranguinho...</span></span></p><br /><p><span style="font-size: 14pt;"><b>O que voc&ecirc; faz para manter a forma? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Uma rotina extremamente doutrinada focada na minha alimenta&ccedil;&atilde;o e exerc&iacute;cios funcionais di&aacute;rios.</span></span></p><br /><p><span style="font-size: 14pt;"><b>Qual a parte do seu corpo que voc&ecirc; mais gosta?</b></span></p><p><span style="font-weight: 400; font-size: 14pt;">Sempre foco na minha parte mais definida, n&atilde;o deixando de lado as outras...</span></p><br /><p><span style="font-size: 14pt;"><b>O que um homem tem que ter para te conquistar? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Generalizar n&atilde;o &eacute; meu forte apenas aprecio cada personalidade. No entanto, n&atilde;o nego que algu&eacute;m com atitude t&ecirc;m um diferencial.</span></span></p><br /><p><span style="font-size: 14pt;"><b>Conte alguma curiosidade interessante sobre voc&ecirc;... </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Ser interessante e saber se reinventar.</span></span></p><br /><p><span style="font-size: 14pt;"><b>Torce para algum time? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">N&atilde;o tor&ccedil;o para ningu&eacute;m, gosto de ser ecl&eacute;tica.</span></span></p><br /><p><span style="font-size: 14pt;"><b>O que voc&ecirc; te leva a loucura na hora H? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Um elogio bem pertinho do ouvido...</span></span></p><br /><p><span style="font-size: 14pt;"><b>Defina sua personalidade em tr&ecirc;s palavras&hellip; </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Atrevida, carism&aacute;tica e determinada</span></span></p><br /><p><span style="font-size: 14pt;"><b>Qual a sua dica para apimentar uma rela&ccedil;&atilde;o? </b><b><br /></b><span style="font-weight: 400;">Nada que um bom vinho, algumas velas e ousadia n&atilde;o solucionem.</span></span></p><br /><p><span style="font-size: 14pt;"><b>Toparia um m&eacute;nage? J&aacute; fez? </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Sim, onde come um come dois!&nbsp;</span></span></p><br /><p><span style="font-size: 14pt;"><b>Voc&ecirc; gosta muito da praia e natureza certo? Fale mais sobre essa conex&atilde;o.&nbsp;</b></span></p><p><span style="font-weight: 400; font-size: 14pt;">Eu me mudei atr&aacute;s de praia e maconha, n&atilde;o sei se era isso que deveria dizer. Mas um bom banho de sol com &aacute;gua salgada e uma flor podem renovar as energias da semana. Trazendo aquela paz...</span></p><br /><p><span style="font-size: 14pt;"><b>J&aacute; ficou com alguma mulher? Ficaria?&nbsp; </b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Sim, o prazer n&atilde;o tem apenas um g&ecirc;nero.&nbsp;</span></span></p><br /><p><span style="font-size: 14pt;"><b>Qual o lugar mais diferente que voc&ecirc; transou?</b></span></p><p><span style="font-weight: 400; font-size: 14pt;">Na sa&iacute;da de emerg&ecirc;ncia em um shopping center.</span></p><p><span style="font-size: 14pt;"><span style="font-weight: 400;"><br /></span><b>J&aacute; tinha feito algum ensaio nu antes?</b><span style="font-weight: 400;"><br /></span><span style="font-weight: 400;">Em um comercial indiano de lingerie fiz algo parecido com um top less...</span></span></p><br /><p><span style="font-size: 14pt;"><b>Conta pra gente como posar para o Bella da Semana!&nbsp;</b></span></p><p><span style="font-weight: 400; font-size: 14pt;">&Eacute; preciso ter muita atitude e personalidade, pois as opini&otilde;es variam e saber reagir com jogo de cintura e simpatia...</span></p>
    `,
  cardsWallPappers: [
    {
      id: 1,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/158204117489530985ead6c2b38cd5345f47c6fab8552.jpg'
    },
    {
      id: 2,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/1582041271093496b38aff75a97a4c455d80bcdbf1260.jpg'
    },
    {
      id: 3,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/158204117489530985ead6c2b38cd5345f47c6fab8552.jpg'
    },
    {
      id: 4,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/1582041271093496b38aff75a97a4c455d80bcdbf1260.jpg'
    },
    {
      id: 5,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/158204117489530985ead6c2b38cd5345f47c6fab8552.jpg'
    },
    {
      id: 6,
      imgPath:
        'https://api.belladasemana.com.br/storage/wallpapers/1582041271093496b38aff75a97a4c455d80bcdbf1260.jpg'
    }
  ],
  credits: [
    {
      function: 'Fotos',
      persons: 'Alex Ribeiro'
    },
    {
      function: 'Produção',
      persons: 'Daniella Ribeiro'
    },
    {
      function: 'Filmagem',
      persons: 'Sidney Kair'
    },
    {
      function: 'Cabelo e Maquiagem',
      persons: 'Pâmella Lummertz'
    }
  ]
}

export const dataColumns = {
  postsColumns: [
    {
      id: 1,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687188988-thumb-bmw.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Jet Set'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Jet Set'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 2,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Jet Set'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Jet Set'
        }
      ],
      date: '10/06/2023'
    },
    {
      banner: true
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Do que elas gostam'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Do que elas gostam'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 4,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Destino exótico'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Destino exótico'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Do que elas gostam'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Do que elas gostam'
        }
      ],
      date: '10/06/2023'
    },
    {
      banner: true
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Do que elas gostam'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Do que elas gostam'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.',
          categoryName: 'Do que elas gostam'
        },
        {
          language_id: 2,
          content: 'post.meta_description',
          categoryName: 'Do que elas gostam'
        }
      ],
      date: '10/06/2023'
    }
  ]
}

export const dataBlogs = {
  blogs: [
    {
      id: 1,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687188988-thumb-bmw.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 2,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 3,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 4,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 5,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 6,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 7,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 8,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 10,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover:
        'https://api.belladasemana.com.br/storage/blog/cover-pt-1678110875-social-media-thumb-2.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    },
    {
      id: 11,
      title: 'Vinho  Cohiba é lançado no Brasil',
      slug: 'post.url',
      cover: 'https://api.belladasemana.com.br/storage/blog/cover-pt-1687790345-thumb-blogpost.jpg',
      comments: 5,
      meta_description: [
        {
          language_id: 1,
          content:
            'Loucos por Churros. Somos Loucos por Churros, assados, crocantes, deliciosos e fresquinhos feitos na hora. Venha se deliciar e conhecer nossos churros gourmet.'
        },
        {
          language_id: 2,
          content: 'post.meta_description'
        }
      ],
      date: '10/06/2023'
    }
  ]
}
export const dataEcards = {
  postsCarroselModels: [
    {
      id: 1,
      title: 'Carolinny Viera',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767147bd858f728451e2c459ef48caa8293b754.jpg'
    },
    {
      id: 2,
      title: 'Renata Matos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689615767319c5cf8f80b68e6a31aaeb503ef26f8b136.jpg'
    },
    {
      id: 3,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
    },
    {
      id: 4,
      title: 'Fernanda Campos',
      cover:
        'https://api.belladasemana.com.br/storage/home/1689130984d162b0635b5b41bb08f8044003a76249b178.jpg'
    },
    {
      id: 5,
      title: 'Fernanda Campos',
      cover: 'https://api.belladasemana.com.br/storage/freetour/pictures/10_cover.jpg'
    }],
  modelsArray: [{
    id: 1,
    title: 'Carolinny Viera',
    cover: 'https://api.belladasemana.com.br/storage/freetour/pictures/4_cover.jpg'
  },
  {
    id: 2,
    title: 'Renata Matos',
    cover:
      'https://api.belladasemana.com.br/storage/home/1689615767319c5cf8f80b68e6a31aaeb503ef26f8b136.jpg'
  },
  {
    id: 3,
    title: 'Fernanda Campos',
    cover: 'https://api.belladasemana.com.br/storage/freetour/pictures/13_cover.jpg'
  },
  {
    id: 4,
    title: 'Fernanda Campos',
    cover:
      'https://api.belladasemana.com.br/storage/home/1689130984d162b0635b5b41bb08f8044003a76249b178.jpg'
  },
  {
    id: 5,
    title: 'Fernanda Campos',
    cover:
      'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
  },
  {
    id: 6,
    title: 'Fernanda Campos',
    cover: 'https://api.belladasemana.com.br/storage/freetour/pictures/10_cover.jpg'
  },
  {
    id: 7,
    title: 'Fernanda Campos',
    cover:
      'https://api.belladasemana.com.br/storage/home/168852603709f068503a58bbdd82cbc42d135724cab218.jpg'
  },
  {
    id: 8,
    title: 'Renata Matos',
    cover: 'https://api.belladasemana.com.br/storage/freetour/pictures/3_cover.jpg'
  },
  ],
}

export const dataBellacloudAlbums = {
  albums: [
    {
      id: 1,
      title: 'Álbum 001'
    },
    {
      id: 2,
      title: 'Álbum 002'
    },
    {
      id: 3,
      title: 'Álbum 003'
    },
    {
      id: 4,
      title: 'Álbum 004'
    },
    {
      id: 5,
      title: 'Álbum 005'
    },
  ]  
}
